import { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { AppShell, AppShellHeader, AppShellNavbar, AppShellMain, Loader, Image, Center, Stack, Tooltip, UnstyledButton } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCodeCompare, faChartSimple, faFileExport, faBell, faPersonWalkingDashedLineArrowRight, faFileInvoice} from '@fortawesome/free-solid-svg-icons';
import classes from './ProtectedRoutes.module.css';
import wallpaper from '../../content/Images/Icon.jpeg';


const mockdata = [
    { icon: faBell, label: 'Alertas', path: 'Home' },
    { icon: faCodeCompare, label: 'Conciliacion', path: 'Conciliaciones' },
    { icon: faFileExport, label: 'Reportes', path: 'Reportes' },
    { icon: faFileInvoice, label: 'Reportes RDI', path: 'ReportesRDI' },
    { icon: faChartSimple, label: 'Cifras de control RDI', path: 'CifrasRDI' }
];

function NavbarLink({ icon: Icon, label, active, onClick }) {
    return (
        <Tooltip label={label} position="right" transitionProps={{ duration: 0 }}>
            <UnstyledButton onClick={onClick} className={classes.link} data-active={active || undefined}>
                <FontAwesomeIcon icon={Icon} size="2x" />
            </UnstyledButton>
        </Tooltip>
    );
}


const ProtectedRoute = () => {
    const [active, setActive] = useState(0);
    const { isAuthenticated, isLoading } = useAuth0();


    const navigate = useNavigate();
    const { logout } = useAuth0();
    const handleClick = (index, path) => {
        setActive(index);
        navigate('/' + path);
    };

    const cierre_sesion = () => {
        console.log("cierra sesion")
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        logout();
    }

    const links = mockdata.map((link, index) => (
        <NavbarLink
            {...link}
            key={link.label}
            active={index === active}
             onClick={() => handleClick(index, link.path)}
        />
    ));

    if (isLoading) {
        // Optionally show a loading spinner or message
        return (
            <Center style={{ height: '100vh' }}>
                <Loader color="rgba(250, 0, 115, 1)" type="dots" size={200} />
            </Center>
        )
    }

     return (isAuthenticated || sessionStorage.getItem("token") != null) ? (
    //return (
        <AppShell>
            {/* Top Header */}
            <AppShellHeader>

            </AppShellHeader>

            {/* Sidebar / Navbar */}
            <AppShellNavbar p={0}>
                <nav className={classes.navbar}>
                    <Center>
                        <Image
                            src={wallpaper}
                            alt="Login Banner"
                            fit="cover"
                            radius="md"
                            style={{
                                width: '100%',
                                objectPosition: 'center',
                                marginBottom: '1rem',
                            }}
                        />
                    </Center>

                    <div className={classes.navbarMain}>
                        <Stack justify="center" gap={0}>
                            {links}
                        </Stack>
                    </div>

                    <Stack justify="center" gap={0}>
                        <NavbarLink icon={faPersonWalkingDashedLineArrowRight} onClick={cierre_sesion} label="Logout" />
                    </Stack>
                </nav>
            </AppShellNavbar>

            {/* Main Content */}
            <AppShellMain>
                <div className={classes.AppShellMain}>
                    <Outlet />
                </div>
            </AppShellMain>
        </AppShell>
    )
    : <Navigate to="/" />;
};

export default ProtectedRoute;